import React, { useState } from "react";
import "./OurBranch.scss"; 
import branchone from '../../assets/branch-1.jpg'
import branchtwo from '../../assets/branch-2.jpg'
import branchthree from '../../assets/branch-3.jpg'
import { FaCaretLeft } from "react-icons/fa";
import { FaCaretRight } from "react-icons/fa";
import branchlogoOne from '../../assets/branchlogo1.png'
import branchlogoThree from '../../assets/branchlogo3.jpg'
import branchlogoFour from '../../assets/kosmos.png'


const branches = [
  {
    branchlogo : branchlogoOne,
    title: "KOSMOS RUWI BRANCH",
    address: "Al Ghubrah South, Way No. 4021, Muscat 133, Oman",
    image: branchone,
  },
  {
    branchlogo : branchlogoOne,
    title: "KOSMOS GHALA BRANCH",
    address: "Al Ghubrah South, Way No. 4021, Muscat 133, Oman",
    image: branchtwo,
  },
  {
    branchlogo : branchlogoThree,
    title: "RIAZ SPORTS",
    address: "Al Ghubrah South, Way No. 4021, Muscat 133, Oman",
    image: branchtwo,
  },
  {
    branchlogo : branchlogoFour,
    title: "KOSMOS BADMINTON ACADEMY",
    address: "Al Ghubrah South, Way No. 4021, Muscat 133, Oman",
    image: branchthree,
  },
];

const OurProduct = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const handlePrev = () => {
    setActiveIndex((prev) =>  Math.max(prev - 1, 0));
  };

  const handleNext = () => {
    setActiveIndex((next) => Math.min(next + 1, branches.length - 1));
  };

  return (
    <div>
        <div>
        <h1 className='our-branch-heading'><span style={{color:'gray'}}>OUR</span> BRANCH</h1>
      <hr />
        </div>
        <div className="our-branch-main-container" style={{display:'flex', padding:'50px', width:'100%',justifyContent:'space-between'}}>
        <div className="our-branch-top" style={{display:'flex', flexDirection:'column', justifyContent:'space-between'}}>
        <div className="our-branch-title" style={{padding:'100px 0px'}}>
          <div>BUY. <br /> HIT.<br /> DOMINATE.</div>
        </div>
        <div className="image-action-button" style={{display:'flex'}}>
        <button onClick={handlePrev} className="arrow" disabled={activeIndex === 0}><FaCaretLeft  size={50}/></button>
        <button onClick={handleNext} className="arrow" disabled={activeIndex === branches.length - 1}><FaCaretRight size={50} /></button>
        </div>
        </div>
    
        <div className="our-branch-buttom" style={{display:'flex', flexDirection:'column', gap:'50px'}} >
      <div className="ourbranch">
        {branches.map((branch, index) => (
          <div
            key={index}
            onClick={() => setActiveIndex(index)}
            className={`ourbranch-item ${
              index === activeIndex ? "active" : "inactive"
            }`}
            style={{ backgroundImage: `linear-gradient(#00000000, #000000),url(${branch.image})`, cursor:'pointer' }}
          >
            {index === activeIndex && (
              <div>
                <img src={branch.branchlogo} alt="branchlogo" className="branch-logo" />
                <div className="content">
                <h3>{branch.title}</h3>
                <p style={{fontSize:'1rem'}}>{branch.address}</p>
                <button className="orange-btn">0{index+1}</button>
              </div>
              </div>
              
            )}
            {index !== activeIndex && (
              <div className="inactive-content">
                <div style={{display:'flex', flexDirection:'column', gap:'20px', alignItems:'flex-end'}}>
                <img src={branch.branchlogo} alt="branchlogo" style={{rotate:'270deg', width:'40px'}} />
                <h3 style={{writingMode:'sideways-lr'}}>{branch.title}</h3>
                </div>
            </div>   
            )}
          </div>
        ))}
      </div>

        <div>
        <p className="branch-description">
            Your one-stop shop for all things badminton, cricket, football, and more.
            Located in the heart of the city with easy access and parking.
            Known for friendly service and regular product updates.
          </p>
        </div>
      </div>
        </div>
        </div>
  );
};

export default OurProduct;


